import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';
import { FieldProps } from 'formik';

import SVGIcon from 'lib/images/svg-icon-view';

import enabled from 'four-nets/icons/svg/icon_radio_enabled.svg';
import disabled from 'four-nets/icons/svg/icon_radio_disabled.svg';

import defaultStyles from './radio-input.scss';

type FormikField = FieldProps['field'] | { onChange: (event: React.ChangeEvent<HTMLInputElement>) => any; value: any };

export interface Props {
    styles: typeof defaultStyles;
    field: FormikField;
    id: string;
    label?: React.ReactNode;
    disabled?: boolean;
}

class RadioInput extends React.Component<Props> {
    render() {
        const { styles, field, id, label, disabled: disabledProp } = this.props;
        const { value } = field;

        return (
            <span className={styles.radioInput}>
                <label className={classnames(styles.label, { [styles.disabled]: disabledProp && id !== value })}>
                    <input
                        className={styles.input}
                        type='radio'
                        id={id}
                        checked={id === value}
                        {...field}
                        value={id}
                        disabled={disabledProp}
                    />
                    <SVGIcon
                        src={id === value ? enabled : disabled}
                        className={classnames(styles.icon, { [styles.disabled]: disabledProp && id !== value })}
                    />
                    {label || null}
                </label>
            </span>
        );
    }
}

export default Styled(defaultStyles)(RadioInput);
